import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import { useMemo } from 'react';
import { WorkstreamStatus } from '@/modules/__generated__/graphql/switchboard-generated';
import { WorkstreamStatusChip } from '@/modules/shared/components/chips/workstream-status-chip';
import { MultipleSelector, type Option } from '@/modules/shared/components/form/multiselect';
interface StatusSelectProps {
  statuses: WorkstreamStatus[];
  setStatuses: (statuses: WorkstreamStatus[]) => Promise<URLSearchParams>;
  className?: string;
}
const statusOptions: Option[] = [{
  value: WorkstreamStatus.RfpDraft,
  label: <WorkstreamStatusChip status={WorkstreamStatus.RfpDraft} />,
  group: 'Statuses'
}, {
  value: WorkstreamStatus.PreworkRfc,
  label: <WorkstreamStatusChip status={WorkstreamStatus.PreworkRfc} />,
  group: 'Statuses'
}, {
  value: WorkstreamStatus.RfpCancelled,
  label: <WorkstreamStatusChip status={WorkstreamStatus.RfpCancelled} />,
  group: 'Statuses'
}, {
  value: WorkstreamStatus.OpenForProposals,
  label: <WorkstreamStatusChip status={WorkstreamStatus.OpenForProposals} />,
  group: 'Statuses'
}, {
  value: WorkstreamStatus.ProposalSubmitted,
  label: <WorkstreamStatusChip status={WorkstreamStatus.ProposalSubmitted} />,
  group: 'Statuses'
}, {
  value: WorkstreamStatus.Awarded,
  label: <WorkstreamStatusChip status={WorkstreamStatus.Awarded} />,
  group: 'Statuses'
}, {
  value: WorkstreamStatus.InProgress,
  label: <WorkstreamStatusChip status={WorkstreamStatus.InProgress} />,
  group: 'Statuses'
}, {
  value: WorkstreamStatus.Finished,
  label: <WorkstreamStatusChip status={WorkstreamStatus.Finished} />,
  group: 'Statuses'
}, {
  value: WorkstreamStatus.NotAwarded,
  label: <WorkstreamStatusChip status={WorkstreamStatus.NotAwarded} />,
  group: 'Statuses'
}];
function StatusSelect(t0) {
  const $ = _c(11);
  const {
    statuses,
    setStatuses,
    className
  } = t0;
  let t1;
  if ($[0] !== statuses) {
    t1 = statusOptions.filter(option => statuses.includes(option.value as WorkstreamStatus));
    $[0] = statuses;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const selectedOptions = t1;
  let t2;
  if ($[2] !== setStatuses) {
    t2 = options => {
      const values = options.map(_temp);
      setStatuses(values);
    };
    $[2] = setStatuses;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleChange = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = cn("bg-background dark:bg-background");
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== className) {
    t4 = {
      className
    };
    $[5] = className;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== handleChange || $[8] !== selectedOptions || $[9] !== t4) {
    t5 = <MultipleSelector value={selectedOptions} onChange={handleChange} options={statusOptions} enableSearch={false} groupBy="group" enableSelectAll={true} selectAllGroup="Statuses" placeholder="All Statuses" className={t3} commandProps={t4} customItemRenderer={_temp2} />;
    $[7] = handleChange;
    $[8] = selectedOptions;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}
function _temp2(option_1) {
  return <WorkstreamStatusChip status={option_1.value as WorkstreamStatus} />;
}
function _temp(option_0) {
  return option_0.value as WorkstreamStatus;
}
export { StatusSelect, statusOptions };
export type { StatusSelectProps };